import { RoutePaths } from "@/config/route-paths";
import { AppBreadcrumbsBuilder } from "@/lib/breadcrumbs";
import type { IBreadcrumbItem } from "@cmde/shadcn";
import i18next from "i18next";

export const getOrganizationsListBreadcrumbs = ({
  customerId,
  customerName,
}: {
  customerId: number;
  customerName?: string;
}): IBreadcrumbItem[] => {
  return AppBreadcrumbsBuilder.start()
    .withSportradar()
    .withStatsAdmin()
    .withCustomer({ customerId, customerName })
    .withBreadcrumb({
      title: i18next.t("organizations.list.breadcrumbs.organizations"),
      href: RoutePaths.organizations.list({ customerId }),
    })
    .build();
};
